export default __webpack_public_path__ + "static/media/red-onion.860aff08.png";